import React, { useState } from "react";
import axios from "axios";
import "./styles/LIRCDhealth.css";

const services = ["nginx", "bind9", "isc-dhcp-server", "dhcpcd.service"];

function LIRCDhealth({ harness_IP_address }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusColor, setStatusColor] = useState("default");

  const handleStatusCheck = async (service) => {
    setLoading(true);
    try {
      const response = await axios.get(`/v1/send_ir/lircd-helth`);
      setMessage(response.data);
      // Determine the color based on status in the message
      if (response.data.includes("Active: active")) {
        setStatusColor("green");
      } else {
        setStatusColor("red");
      }
    } catch (error) {
      setMessage(
        `Error: ${error.response ? error.response.data : error.message}`
      );
      setStatusColor("red");
    } finally {
      setLoading(false);
    }
  };

  const handleRestart = async (service) => {
    setLoading(true);
    try {
      const response = await axios.get(`/v1/send_ir/restart-lird`);
      setMessage(response.data);
      setStatusColor("default");
    } catch (error) {
      setMessage(
        `Error: ${error.response ? error.response.data : error.message}`
      );
      setStatusColor("red");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="system-health">
      <div className="service-box">
        <h3>IR-Blaster</h3>
        <button onClick={() => handleStatusCheck()} disabled={loading}>
          Check Status
        </button>
        <button onClick={() => handleRestart()} disabled={loading}>
          Restart
        </button>
      </div>

      <div className="message-area">
        <h4>Server Message:</h4>
        <pre className={`server-message ${statusColor}`}>
          {loading ? "Loading..." : message}
        </pre>
      </div>
    </div>
  );
}

export default LIRCDhealth;
